import React, { useState, useEffect } from 'react';
import api from '../services/api';

const emptyForm = { name: '', code: '', status: 'ACTIVE', type: 'CUSTOMER', address: '', phone: '', email: '', website: '' };
const emptyS3 = { storageMode: 'S3', bucketName: '', region: '', accessKeyId: '', secretAccessKey: '', prefix: '', active: true };

export default function Companies() {
  const [companies, setCompanies] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(emptyForm);
  const [error, setError] = useState('');

  const [s3Company, setS3Company] = useState(null);
  const [s3Form, setS3Form] = useState(emptyS3);
  const [s3Error, setS3Error] = useState('');
  const [s3Success, setS3Success] = useState('');
  const [s3Testing, setS3Testing] = useState(false);
  const [s3Saving, setS3Saving] = useState(false);

  const load = () => {
    api.get('/companies/all').then(r => setCompanies(r.data)).catch(() => {});
  };
  useEffect(() => { load(); }, []);

  const save = async () => {
    setError('');
    if (!form.name || !form.code) { setError('Name and Code are required'); return; }
    try {
      if (editing) {
        await api.put(`/companies/${editing}`, form);
      } else {
        await api.post('/companies', form);
      }
      setShowForm(false); setEditing(null); setForm(emptyForm); load();
    } catch (e) { setError(e.response?.data?.error || 'Save failed'); }
  };

  const openEdit = (c) => {
    setForm({ name: c.name, code: c.code, status: c.status || 'ACTIVE', type: c.type || 'CUSTOMER', address: c.address || '', phone: c.phone || '', email: c.email || '', website: c.website || '' });
    setEditing(c.id); setShowForm(true); setError('');
  };

  const del = async (id) => {
    if (!window.confirm('Deactivate this company?')) return;
    try {
      await api.delete(`/companies/${id}`);
      load();
    } catch (e) { alert(e.response?.data?.error || 'Failed'); }
  };

  const openS3 = async (company) => {
    setS3Company(company); setS3Error(''); setS3Success('');
    try {
      const r = await api.get(`/companies/${company.id}/s3-config`);
      if (r.status === 204 || !r.data) {
        setS3Form(emptyS3);
      } else {
        setS3Form({
          storageMode: r.data.storageMode || 'S3',
          bucketName: r.data.bucketName || '',
          region: r.data.region || '',
          accessKeyId: r.data.accessKeyId || '',
          secretAccessKey: '',
          prefix: r.data.prefix || '',
          active: r.data.active !== false
        });
      }
    } catch {
      setS3Form(emptyS3);
    }
  };

  const saveS3 = async () => {
    setS3Error(''); setS3Success(''); setS3Saving(true);
    try {
      await api.put(`/companies/${s3Company.id}/s3-config`, s3Form);
      setS3Success('S3 config saved');
      setTimeout(() => setS3Success(''), 2000);
    } catch (e) { setS3Error(e.response?.data?.error || 'Save failed'); }
    finally { setS3Saving(false); }
  };

  const testS3 = async () => {
    setS3Error(''); setS3Success(''); setS3Testing(true);
    try {
      const r = await api.post(`/companies/${s3Company.id}/s3-config/test`, s3Form);
      if (r.data.success) setS3Success(r.data.message);
      else setS3Error(r.data.message);
    } catch (e) { setS3Error(e.response?.data?.message || 'Test failed'); }
    finally { setS3Testing(false); }
  };

  const deleteS3 = async () => {
    if (!window.confirm('Remove S3 config for this company?')) return;
    try {
      await api.delete(`/companies/${s3Company.id}/s3-config`);
      setS3Form(emptyS3); setS3Success('S3 config removed');
      setTimeout(() => setS3Success(''), 2000);
    } catch (e) { setS3Error(e.response?.data?.error || 'Delete failed'); }
  };

  const inputStyle = { width: '100%', padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 14 };
  const labelStyle = { fontSize: 13, fontWeight: 500, display: 'block', marginBottom: 4, color: '#374151' };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <h2 style={{ fontSize: 22, fontWeight: 700, color: '#0f172a' }}>Companies</h2>
        <button className="btn-primary" onClick={() => { setShowForm(true); setEditing(null); setForm(emptyForm); setError(''); }}>+ Add Company</button>
      </div>

      {showForm && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 999 }}>
          <div style={{ background: '#fff', borderRadius: 14, padding: 32, width: 480, maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
            <h3 style={{ fontWeight: 700, marginBottom: 20, color: '#0f172a' }}>{editing ? 'Edit Company' : 'New Company'}</h3>
            {error && <div style={{ background: '#fee2e2', color: '#b91c1c', borderRadius: 8, padding: '10px 14px', marginBottom: 14, fontSize: 13 }}>{error}</div>}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
              <div>
                <label style={labelStyle}>Company Name *</label>
                <input value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} placeholder="Company name" style={inputStyle} />
              </div>
              <div>
                <label style={labelStyle}>Company Code *</label>
                <input value={form.code} onChange={e => setForm({ ...form, code: e.target.value })} placeholder="CMP-001" style={inputStyle} />
              </div>
              <div>
                <label style={labelStyle}>Status</label>
                <select value={form.status} onChange={e => setForm({ ...form, status: e.target.value })} style={inputStyle}>
                  <option>ACTIVE</option><option>INACTIVE</option>
                </select>
              </div>
              <div>
                <label style={labelStyle}>Type</label>
                <select value={form.type || 'CUSTOMER'} onChange={e => setForm({ ...form, type: e.target.value })} style={inputStyle}>
                  <option value="CUSTOMER">Customer</option>
                  <option value="VENDOR">Vendor (CLTS)</option>
                </select>
              </div>
              <div>
                <label style={labelStyle}>Phone</label>
                <input value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })} placeholder="+91..." style={inputStyle} />
              </div>
              <div>
                <label style={labelStyle}>Email</label>
                <input value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} placeholder="info@company.com" style={inputStyle} />
              </div>
              <div>
                <label style={labelStyle}>Website</label>
                <input value={form.website} onChange={e => setForm({ ...form, website: e.target.value })} placeholder="https://..." style={inputStyle} />
              </div>
              <div style={{ gridColumn: '1 / -1' }}>
                <label style={labelStyle}>Address</label>
                <textarea rows={2} value={form.address} onChange={e => setForm({ ...form, address: e.target.value })} placeholder="Company address" style={{ ...inputStyle, resize: 'vertical' }} />
              </div>
            </div>
            <div style={{ display: 'flex', gap: 8, marginTop: 20 }}>
              <button className="btn-primary" onClick={save} style={{ flex: 1 }}>{editing ? 'Update' : 'Create'}</button>
              <button className="btn-ghost" onClick={() => { setShowForm(false); setEditing(null); }} style={{ flex: 1 }}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {s3Company && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 999 }}>
          <div style={{ background: '#fff', borderRadius: 14, padding: 32, width: 520, maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
            <h3 style={{ fontWeight: 700, marginBottom: 4, color: '#0f172a' }}>S3 Configuration</h3>
            <p style={{ fontSize: 13, color: '#64748b', marginBottom: 20 }}>{s3Company.name} ({s3Company.code})</p>
            {s3Error && <div style={{ background: '#fee2e2', color: '#b91c1c', borderRadius: 8, padding: '10px 14px', marginBottom: 14, fontSize: 13 }}>{s3Error}</div>}
            {s3Success && <div style={{ background: '#dcfce7', color: '#15803d', borderRadius: 8, padding: '10px 14px', marginBottom: 14, fontSize: 13 }}>{s3Success}</div>}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
              <div style={{ gridColumn: '1 / -1' }}>
                <label style={labelStyle}>Bucket Name *</label>
                <input value={s3Form.bucketName} onChange={e => setS3Form({ ...s3Form, bucketName: e.target.value })} placeholder="my-bucket" style={inputStyle} />
              </div>
              <div>
                <label style={labelStyle}>Region *</label>
                <input value={s3Form.region} onChange={e => setS3Form({ ...s3Form, region: e.target.value })} placeholder="ap-south-1" style={inputStyle} />
              </div>
              <div>
                <label style={labelStyle}>Prefix</label>
                <input value={s3Form.prefix} onChange={e => setS3Form({ ...s3Form, prefix: e.target.value })} placeholder="folder/path" style={inputStyle} />
              </div>
              <div>
                <label style={labelStyle}>Access Key ID *</label>
                <input value={s3Form.accessKeyId} onChange={e => setS3Form({ ...s3Form, accessKeyId: e.target.value })} placeholder="AKIA..." style={inputStyle} />
              </div>
              <div>
                <label style={labelStyle}>Secret Access Key</label>
                <input type="password" value={s3Form.secretAccessKey} onChange={e => setS3Form({ ...s3Form, secretAccessKey: e.target.value })} placeholder="Leave blank to keep existing" style={inputStyle} />
              </div>
              <div style={{ gridColumn: '1 / -1', display: 'flex', alignItems: 'center', gap: 8 }}>
                <input type="checkbox" checked={s3Form.active} onChange={e => setS3Form({ ...s3Form, active: e.target.checked })} id="s3active" />
                <label htmlFor="s3active" style={{ fontSize: 13, fontWeight: 500 }}>Active</label>
              </div>
            </div>
            <div style={{ display: 'flex', gap: 8, marginTop: 20 }}>
              <button className="btn-primary" onClick={saveS3} disabled={s3Saving} style={{ flex: 1 }}>{s3Saving ? 'Saving...' : 'Save Config'}</button>
              <button className="btn-ghost" onClick={testS3} disabled={s3Testing} style={{ flex: 1 }}>{s3Testing ? 'Testing...' : 'Test Connection'}</button>
            </div>
            <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
              <button className="btn-ghost" onClick={deleteS3} style={{ flex: 1, color: '#dc2626' }}>Remove Config</button>
              <button className="btn-ghost" onClick={() => { setS3Company(null); setS3Error(''); setS3Success(''); }} style={{ flex: 1 }}>Close</button>
            </div>
          </div>
        </div>
      )}

      <div className="card">
        {companies.length === 0 ? (
          <div style={{ textAlign: 'center', padding: 40, color: '#9ca3af' }}>
            <div style={{ fontSize: 40, marginBottom: 12 }}>🏢</div>
            <div>No companies yet</div>
          </div>
        ) : (
          <table>
            <thead>
              <tr><th>Code</th><th>Company Name</th><th>Type</th><th>Email</th><th>Phone</th><th>Status</th><th>Actions</th></tr>
            </thead>
            <tbody>
              {companies.map(c => (
                <tr key={c.id}>
                  <td style={{ fontWeight: 600, color: '#1a56db' }}>{c.code}</td>
                  <td>{c.name}</td>
                  <td><span className={`badge ${c.type === 'VENDOR' ? 'badge-info' : 'badge-gray'}`}>{c.type || 'CUSTOMER'}</span></td>
                  <td style={{ color: '#6b7280', fontSize: 13 }}>{c.email || '-'}</td>
                  <td style={{ color: '#6b7280', fontSize: 13 }}>{c.phone || '-'}</td>
                  <td><span className={`badge ${c.status === 'ACTIVE' ? 'badge-success' : 'badge-danger'}`}>{c.status}</span></td>
                  <td>
                    <div style={{ display: 'flex', gap: 4 }}>
                      <button className="btn-ghost" onClick={() => openEdit(c)} style={{ padding: '4px 10px', fontSize: 12 }}>Edit</button>
                      <button className="btn-ghost" onClick={() => openS3(c)} style={{ padding: '4px 10px', fontSize: 12, color: '#2563eb' }}>S3 Config</button>
                      {c.status === 'ACTIVE' && <button className="btn-ghost" onClick={() => del(c.id)} style={{ padding: '4px 10px', fontSize: 12, color: '#dc2626' }}>Deactivate</button>}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
